<div class="flex flex-col gap-2">
  <!-- playoffs conditions message / create playoffs -->
  @if(authService.hasRole(['admin', 'staff'])) {
    <div class="flex gap-2 items-center">
      <p-message icon="pi pi-info-circle" class="flex flex-1" [severity]="'info'">
        {{ 'playoffs-conditions' | translate }}
      </p-message>
      <p-button icon="pi pi-arrow-right" class="add-button mr-4" rounded (click)="createPlayoffs($event)"
        [pTooltip]="'button.generate-playoffs' | translate" tooltipEvent="hover" tooltipPosition="left"
        [disabled]="!allowCreatePlayoffs" [ngClass]="{'blink': allowCreatePlayoffs}" />
    </div>
  }
  <!-- select round -->
  <p-select [options]="rounds" [optionLabel]="'name'" [(ngModel)]="selectedRound"
    appendTo="body" (onChange)="changeRound()" [style]="{ width: '100%' }" [className]="'round-select'" />
  <!-- matches -->
  @if(matchesByGroup.length) {
    <div class="flex flex-col gap-6 mt-4">
      @for(groupMatches of matchesByGroup; track $index) {
        <div class="flex flex-col">
          <div class="group-name">
            {{ groupMatches.group.groupName }}
          </div>
          <app-matches [matches]="groupMatches.matches" [stage]="'ROUNDS'"
            (updateEvent)="checkTournamentStatus(); checkAllMatchesFinished()"></app-matches>
        </div>
      }
    </div>
  }
</div>

<!-- create playoffs confirm dialog -->
<p-confirmdialog #confirmPlayoffs [style]="{'max-width': '600px'}">
  <ng-template pTemplate="content" let-message>
    <div>{{ message.message }}</div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button [label]="'button.cancel' | translate" styleClass="p-confirmpopup-reject-button" size="small"
      severity="secondary" (click)="confirmPlayoffs.hide()"></p-button>
    <p-button [label]="'button.show-standings' | translate" styleClass="p-confirmpopup-reject-button" size="small"
      severity="secondary" (click)="showStandings()"></p-button>
    <p-button [label]="'button.generate-playoffs' | translate" styleClass="p-confirmpopup-accept-button" size="small"
      (click)="confirmPlayoffs.onAccept()"></p-button>
  </ng-template>
</p-confirmdialog>
